import clsx from "clsx";

type VerticalDividerProps = {
  color?: string;
  className?: string;
  compact?: boolean;
};

const VerticalDivider = ({
  color,
  className,
  compact
}: VerticalDividerProps) => (
  <div
    className={clsx(
      "vertical-divider",
      color && `background-${color}`,
      compact && "vertical-divider--compact",
      className
    )}
  />
);

export default VerticalDivider;
